module.exports = __webpack_public_path__ + "img/tab01.c97f91f4.jpg";